import React, { useEffect } from 'react';
import { useHistory, withRouter } from 'react-router-dom';
import DeedsySpinner from 'src/components/DeedsySpinner/DeedsySpinner';
import { getQueryParam } from 'src/utilities/queryParams';
import { authenticateMagicToken } from 'src/services/account';
import { compose } from 'ramda';
import { loginAccount } from '../Login/loginAccounts';

/** * The module that has the process to solve the MagickLink *
 * Use case 1 * ========== *
 * 1. Loan officer sends an invitation from Encompass *
 * 2. User receives a magic link with a token + email as a param *
 * 3. Upon setting that up, the LoggedInCallback route is called. The usual * process takes over. */ //////////////////////////////////////////////////////////////////////////////////////

const MagicLinkLanding = (props: any) => {
  const { match } = props;
  const { token } = match.params;
  const email = getQueryParam(location.search, 'email');
  const history = useHistory();
  const authenticateMagicLinkUser = async () => {
    try {
      const userResp = await authenticateMagicToken({ email, password: token });
      loginAccount(userResp, history, false);
    } catch (error) {
      history.push('/login');
    }
  };
  useEffect(() => {
    authenticateMagicLinkUser();
  }, []);
  return <DeedsySpinner />;
};
export default compose(withRouter)(MagicLinkLanding);
